/* eslint-disable */
/* this file generate by raw-icons/build.js */

import React from 'react';

const zoomOut = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      d="M35.898 31.106l8.11 8.11a3.388 3.388 0 11-4.793 4.792l-8.11-8.11A17.917 17.917 0 0121 39c-9.941 0-18-8.059-18-18S11.059 3 21 3s18 8.059 18 18c0 3.746-1.144 7.225-3.102 10.106zM21 33c6.627 0 12-5.373 12-12S27.627 9 21 9 9 14.373 9 21s5.373 12 12 12zm7.5-13.5v3a1 1 0 01-1 1h-13a1 1 0 01-1-1v-3a1 1 0 011-1h13a1 1 0 011 1z"
    />
  </svg>
);

export default zoomOut;
